import React from 'react'
import {forwardRef} from 'react'
import classnames from 'classnames'

import {TButtonBaseProps, TIconPositions} from '../../../ui/styleGenerators/button/types'
import {TTypographyProps} from '../../../ui/styleGenerators/typography/types'
import {btn} from '../../styleGenerators/button'
import {Icon} from '../Icon/Icon'
import {TIcon, TIconSize} from '../Icon/types'

import btnStyles from '../../../ui/styleGenerators/button/styles.module.css'

export type TButtonProps = {
  typographyProps?: TTypographyProps
  icon?: TIcon
  iconPosition?: TIconPositions
  iconColor?: string
  iconSize?: TIconSize
  isIconAbsolutePos?: boolean
  disabled?: boolean
  className?: string
  children?: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
} & TButtonBaseProps

export const Button = forwardRef(function Button(props: TButtonProps, ref) {
  const {
    size = 'm',
    stretchToFillContainer = false,
    disabled = false,
    shape = 'rounded',
    variant = 'primary',
    icon,
    iconColor,
    iconPosition = 'right',
    iconSize = 'm',
    isIconAbsolutePos = false,
    typographyProps,
    children,
    className,
    ...buttonProps
  } = props

  return (
    <button
      ref={ref as React.RefObject<HTMLButtonElement>}
      className={classnames(
        btn({
          variant,
          size,
          stretchToFillContainer,
          shape,
          ...(typographyProps ? typographyProps : {}),
        }),
        className,
      )}
      {...buttonProps}
      disabled={disabled}
    >
      {iconPosition === 'right' && children}
      {icon && (
        <Icon
          name={icon}
          size={iconSize}
          {...(iconColor ? {color: iconColor} : {})}
          className={classnames(btnStyles.img, btnStyles[`${iconPosition}${isIconAbsolutePos ? 'Edge' : ''}`])}
        />
      )}
      {iconPosition === 'left' && children}
    </button>
  )
})
